import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
  },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
  },
  {
    title: T("数量"),
    dataIndex: "total_quantity",
  },
  {
    title: T("单位"),
    dataIndex: "unit",
  },
  {
    title: T("单位重量(千克)"),
    dataIndex: "unit_weight",
  },
  {
    title: T("总重量(吨)"),
    dataIndex: "total_weight",
  },
  {
    title: T("单位面积(平方米)"),
    dataIndex: "unit_area",
  },
  {
    title: T("总面积(平方米)"),
    dataIndex: "total_area",
  },
  {
    title: T("单位体积(立方米)"),
    dataIndex: "unit_volume",
  },
  {
    title: T("总体积(立方米)"),
    dataIndex: "total_volume",
  },
  {
    title: T("托盘尺寸"),
    dataIndex: "pallet_size",
  },
  {
    title: T("备注"),
    dataIndex: "remark",
  },
  {
    title: T("规格"),
    dataIndex: "material_spec",
  },
];
